import React from 'react'
import { useTranslation } from 'react-i18next'

import { DataTable } from 'components/DataTable'
import { Checkbox } from 'components/forms'
import { ingredients_nutrients } from '../../../tableColumns'

const IngredientsTable = ({ allIngrs = [], productIngrs = [], isIngrsLinked, productId, onAddIngredient, onDelete, mutateProduct, ingredientGroup, product, disabled, ...restProps }) => {
	const [t] = useTranslation()
	const allergensCols = [
		{
			Header: t('product_section.fields.number'),
			accessor: 'code'
		}, {
			Header: t('product_section.fields.comprise'),
			accessor: 'contains',
			Cell: ({ value, original }) => {
				const findProdIngr = arr => arr?.find(({ ingredientId, allergenUUID }) => {
					if(allergenUUID) {
						return original.uuid === allergenUUID
					}
					return Number(original.id) === Number(ingredientId)
				}) || {}
				const prodIngr = findProdIngr(productIngrs)
				const checkboxVal = prodIngr.contains
				return (
					<Checkbox
						key={isIngrsLinked}
						noForm
						checked={!!checkboxVal}
						onChange={e => {
							const isChecked = e.target.checked
							const mutationVars = {
								...original.productIngrId && { id: original.productIngrId },
								...isChecked && {
									ingredientId: original.id,
									contains: isChecked
								}
							}
							const getOptimIngrs = (arr, item) => {
								let newItem = item
								if(Number(item.ingredientId) === Number(original.id)) {
									newItem = { ...newItem, contains: isChecked }
								}
								return [...arr, { ...newItem, __typename: 'ProductIngredient' }]
							}
							const optimisticIngr = productIngrs.length ? [{
								...productIngrs[0],
								id: '-1',
								ingredientId: original.id,
								contains: isChecked,
								ingredient: { ...productIngrs[0]?.ingredient, id: original?.id, name: original?.name, code: original?.code }
							}] : []
							const newIngrs = original.productIngrId ? productIngrs : [...productIngrs, ...optimisticIngr]
							const optimisticResponse = {
								cashAssist: {
									updateProduct: {
										mod_ver: -1,
										...product,
										ingredients: newIngrs.reduce(getOptimIngrs, []),
										__typename: 'Product'
									},
									__typename: 'CA_Mutation'
								},
								__typename: 'Mutation'
							}
							mutateProduct({ ingredients: [{ ...mutationVars }] }, { optimisticResponse })
						}}
						stopPropagation
					/>
				)
			}
		}, {
			Header: t('product_section.fields.name'),
			accessor: 'name'
		}
	]
	const columns = ingredientGroup === 'nutrients' ? ingredients_nutrients(t) : allergensCols
	const tableData = allIngrs.map(ingr => {
		const productIngr = productIngrs?.find(({ ingredientId, ingredientUUID }) => {
			if(ingredientId) {
				return Number(ingredientId) === Number(ingr.id)
			}
			return ingredientUUID === ingr.uuid
		})
		const filteredIngr = {}
		Object.keys(ingr).forEach(field => {
			if(field !== '__typename') {
				filteredIngr[field] = ingr[field]
			}
		})

		return({
			...filteredIngr,
			...productIngr && { productIngrId: productIngr.id },
			...ingredientGroup === 'nutrients' && { amount: productIngr ? productIngr.amount : null },
			...ingredientGroup === 'allergens_EU' && { contains: productIngr ? productIngr.contains : 0 }
		})
	})

	const filteredTableData = tableData.filter(i => i.code !== null)
	const rowsWithDel = ingredientGroup === 'nutrients' ?
		filteredTableData.reduce((acc, { id, amount }) => Number(amount) ? [...acc, id] : acc, [])
		: []
	return(
		<DataTable
			{...restProps}
			data={filteredTableData}
			columns={columns}
			defaultSorted={[
				{
				  id: 'code',
				  desc: false
				}
			  ]}
			mutateRow={{
				onRowMutate: val => {
					const productIngrId = productIngrs.find(({ ingredientId }) => Number(ingredientId) === Number(val)).id
					if(mutateProduct) {
						const optimisticResponse = {
							cashAssist: {
								updateProduct: {
									mod_ver: -1,
									...product,
									ingredients: productIngrs.reduce((arr, item) => {
										if(Number(item.ingredientId) === Number(val)) {
											return arr
										}
										return [...arr, { ...item, __typename: 'ProductIngredient' }]
									}, []),
									__typename: 'Product'
								},
								__typename: 'CA_Mutation'
							},
							__typename: 'Mutation'
						}
						mutateProduct({ ingredients: [{ id: productIngrId }] }, { optimisticResponse })
					}
					if(onDelete) {
						onDelete()
					}
				},
				deleteBtns: rowsWithDel
			}}
			onAddRecord={() => isIngrsLinked ? null : onAddIngredient()}
			disabled={!!disabled}
		/>
	)
}

export default IngredientsTable
